import React from 'react';
import { useNavigate } from "react-router-dom";
import WorkingOnIt from '../../assets/images/svg-icons-material-io/downloading_FILL0_wght400_GRAD0_opsz48.svg';

const DownloadProgressModal = () => {
    let navigate = useNavigate();
    const routeDownloadStatus = () => {
        let path = '/download-status';
        navigate(path)
    }

    return (
        <div className="Download">
            <div className="modal fade" id="downloadProgressModal" data-backdrop="static" data-keyboard="false" tabIndex="-1" role="dialog" aria-labelledby="DownloadProgress" aria-hidden="false">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <div className="modal-title spacer-inline" id="myModalLabel">Download</div>
                            <button type="button" className="close" aria-label="Close" data-dismiss="modal">
                                <span aria-hidden="false">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="ctr">
                                <img src={WorkingOnIt} className="w-md1 filter-orange" title="download in progress" alt="Downloading Icon" />
                                <div className="field-wrapper sp-margin3">
                                    <label>We're working on it...</label>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-success" data-dismiss="modal" onClick={routeDownloadStatus} >Download Status</button>
                            <button type="button" className="btn btn-outline-secondary" data-dismiss="modal">Close</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

DownloadProgressModal.defaultProps = {};

export default DownloadProgressModal;
